import {
  FilterFieldDataType,
  FilterFieldEditorType,
} from '@warebee/shared/common';
import { AssignmentDataColumn } from '@warebee/shared/dataset-queries';
import { TFunction } from 'i18next';
import { FilterFieldConfig } from '../../common/types';
import { Formatter } from '../../common/useFormatter';
import i18n from '../../i18n';

export function getAssignmentFilterConfigDefault(
  t: TFunction<'app'> = i18n.t,
  formatter?: Formatter,
): FilterFieldConfig<AssignmentDataColumn>[] {
  return [
    {
      type: 'stockUom',
      title: t(`Stock UOM`, { ns: 'simulation' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'stockUomQuantity',
      title: t(`Stock UOM Qty`, { ns: 'simulation' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.IntegerRange,
    },
  ];
}
